import { ActivityTabs } from "shared/app/TaskTableView/constants";
import { ActivityLog, TaskActivity } from "shared/app/TaskTableView/types";
import { ActivityItemData } from "./ActivityItemData";
import { ActivityItem } from "./ActivityItem";
import { NoteItem } from "./NoteItem";

export const ActivityList = ({
  activityLogs,
  mentionedActivityLogs,
  tab,
  noteId
}: {
  activityLogs: ActivityLog[];
  mentionedActivityLogs: ActivityLog[];
  tab: ActivityTabs;
  noteId?: number;
}) => {
  const filteredLogs =
    tab === ActivityTabs.MENTIONS ? mentionedActivityLogs : activityLogs;

  return (
    <div className="relative">
      <div className="pointer-events-none absolute top-0 bottom-0 left-[36px] border-l border-dashed border-content-100" />
      {filteredLogs.map((log: ActivityLog, idx: number) => {
        const logKey = `activity-${log.id}-${idx}`;
        if (log.activity_type === TaskActivity.NOTE)
          return <NoteItem data={log} key={logKey} noteId={noteId} />;
        const { title, sub, icon } = ActivityItemData(log, log.actor_name);
        return (
          <ActivityItem
            key={logKey}
            item={{
              id: logKey,
              title,
              sub,
              atISO: log.created_at,
              icon
            }}
          />
        );
      })}
    </div>
  );
};
